import React, { PropsWithChildren, useContext, useEffect } from 'react'
import { StoresContext } from '@App/contexts'
import { analyticsSendIdentify } from '@App/common/utils/analytics-utils'
import { OpenFeature, OpenFeatureProvider } from '@openfeature/react-sdk'
import openFeatureUserContext from '@App/helpers/user/open-feature-user-context'
import { observer } from 'mobx-react'
import { LaunchDarklyClientProvider } from '@openfeature/launchdarkly-client-provider'
import useUserpilotConsent from '@Scenes/RootLayout/hooks/use-userpilot-consent'

const ldOpenFeatureProvider = new LaunchDarklyClientProvider(window.APP_CONFIG.LAUNCH_DARKLY_CLIENT_ID || '', {})

interface UserInfoHandlerProps {}

const UserInfoHandler = (props: PropsWithChildren<UserInfoHandlerProps>) => {
    const { userStore } = useContext(StoresContext)
    const { children } = props
    useUserpilotConsent()

    useEffect(() => {
        const userInfo = userStore.userInfo
        if (userInfo) {
            // LaunchDarkly is the current service we are using to implement OpenFeature.
            // We only identity and notify authenticated users to LaunchDarkly to reduce costs.
            void OpenFeature.setProviderAndWait(ldOpenFeatureProvider, openFeatureUserContext(userInfo)).then()
            analyticsSendIdentify(userInfo)
        }
    }, [userStore.userInfo])

    return (
        <>
            <OpenFeatureProvider>{children}</OpenFeatureProvider>
        </>
    )
}

export default observer(UserInfoHandler)
